import { useTrackingDatas } from "./useTracking";
import { useTrackingSite } from "@/contexts/cdpConfig";
import { getUrlPath } from "@/utils";
// TODO !!
// @ts-ignore
export const useTrackingViewMap = () => ({
    av_pagetitle: "classified_detail_map",
    ...useTrackingDatas(),
    av_platform: "web",
    av_url_path: getUrlPath(),
    av_site: useTrackingSite(),
});
